import React, { useEffect, useState } from "react";
import classes from "./Group.module.scss";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../../../../components/Common/Input/Input";
import { useDispatch } from "react-redux";
import { getUserGroupsHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";
import DistributeButton from "../../DistributeButton/DistributeButton";
import { useOutletContext } from "react-router";

const Group = () => {
  const dispatch = useDispatch();
  const { tenantName } = useOutletContext();
  const { selectedUserGroup, setSelectedUserGroup, setLoading } =
    useOutletContext();
  const methods = useForm({});
  const {
    reset,
    formState: { isDirty },
  } = methods;
  const [userGoup, setUserGoup] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    dispatch(getUserGroupsHandler(setUserGoup, setLoader));
  }, [dispatch]);

  const handleTagList = (tagList) => {
    setUserGoup(tagList);
    const updatedData = tagList?.filter((item) => {
      return item?.checked;
    });
    setSelectedUserGroup(updatedData);
  };

  const resetForm = () => {
    reset();
    const updatedData = userGoup?.map((data) => {
      return {
        ...data,
        checked: false,
      };
    });
    setUserGoup(updatedData);
    setSelectedUserGroup([]);
  };

  return (
    <BoxLayout>
      <div className={classes.distribute_to_group}>
        <FormProvider {...methods}>
          <Input
            label="Choose Group"
            name="group"
            fieldName="Name"
            fieldValue="UserGroupId"
            type="noSearchTags"
            placeholder="Search Group"
            labelColor={"light"}
            width="27"
            height="5"
            loading={loader}
            searchTagsList={userGoup || []}
            handleTagList={(tagList) => handleTagList(tagList)}
            handleClickTag={selectedUserGroup?.length === 5 ? true : false}
            // error={"Note : Maximum of five user groups only can be selected."}
            labelMsg="(Max: 5 Groups)"
            searchable={true}
            isTagCheckBoxVisible={
              selectedUserGroup?.length === 5 ? false : true
            }
          />
        </FormProvider>
      </div>
      <DistributeButton
        selectedUserGroup={selectedUserGroup}
        resetForm={resetForm}
        tenantName={tenantName}
        distributedTo={1}
        isDirty={isDirty}
        setLoading={setLoading}
      />
    </BoxLayout>
  );
};

export default Group;
